import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export function useHaptics() {
  const isNative = Capacitor.isNativePlatform();

  const impact = async (style: ImpactStyle = ImpactStyle.Light) => {
    if (!isNative) return;
    try {
      await Haptics.impact({ style });
    } catch (error) {
      console.warn('Haptics not available:', error);
    }
  };

  const notification = async (type: NotificationType = NotificationType.Success) => {
    if (!isNative) return;
    try {
      await Haptics.notification({ type });
    } catch (error) {
      console.warn('Haptics not available:', error);
    }
  };

  const vibrate = async (duration: number = 100) => {
    if (!isNative) return;
    try {
      await Haptics.vibrate({ duration });
    } catch (error) {
      console.warn('Haptics not available:', error);
    }
  };

  const successFeedback = async () => {
    await notification(NotificationType.Success);
  };

  const errorFeedback = async () => {
    await notification(NotificationType.Error);
  };

  const warningFeedback = async () => {
    await notification(NotificationType.Warning);
  };

  const lightTap = async () => {
    await impact(ImpactStyle.Light);
  };

  const mediumTap = async () => {
    await impact(ImpactStyle.Medium);
  };

  const heavyTap = async () => {
    await impact(ImpactStyle.Heavy);
  };

  return {
    impact,
    notification,
    vibrate,
    successFeedback,
    errorFeedback,
    warningFeedback,
    lightTap,
    mediumTap,
    heavyTap,
    isNative,
  };
}
